import BillingDashboard from '@/models/general/settings/BillingDashboard';
import current from './current';
import paymentHistory from './paymentHistory';
import paymentMethods from './paymentMethods';
import emailNotifications from './emailNotifications';
import charges from './charges';

export default {
  namespaced: true,

  modules: {
    current,
    paymentMethods,
    paymentHistory,
    emailNotifications,
    charges,
  },

  actions: {
    async fetchBillingDashboardData({ dispatch, rootState }, options = {}) {
      const { includePaymentHistory = false } = options;

      dispatch('general/settings/billingDashboard/paymentMethods/getPaymentMethods', null, {
        root: true,
      });
      dispatch('general/settings/billingDashboard/current/getCurrent', null, { root: true });

      if (includePaymentHistory) {
        const page =
          rootState.general.settings.billingDashboard.paymentHistory?.pagination?.current_page || 1;

        dispatch(
          'general/settings/billingDashboard/paymentHistory/getPaymentHistory',
          `?page=${page}`,
          { root: true }
        );
      }

      dispatch('general/settings/billingDashboard/emailNotifications/getEmails', null, {
        root: true,
      });
    },

    async calculateBilling({ dispatch }, id) {
      try {
        const { data } = await BillingDashboard.calculateBilling(id);
        if (!data.error) {
          dispatch('fetchBillingDashboardData');
        }
        return data;
      } catch (error) {
        console.error(error);
        return error.response.data;
      }
    },
  },
};
